export default __webpack_public_path__ + "static/media/boost-01.804354f0.webp";